import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import {
  needsAttentionSearchSchema,
  type NeedsAttentionSearch,
} from '~/features/catalog-enrichment/utils/needs-attention-search';

const NeedsAttentionPage = lazy(
  () => import('~/features/catalog-enrichment/pages/needs-attention-page'),
);

export const Route = createFileRoute('/_authenticated/_tenant/catalog-enrichment/needs-attention')({
  validateSearch: needsAttentionSearchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();

  // Filter/page changes replace the history entry so Back leaves the screen, not the filter.
  const onSearchChange = (patch: Partial<NeedsAttentionSearch>) => {
    void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true });
  };

  return (
    <Suspense fallback={<PageSkeleton />}>
      <NeedsAttentionPage search={search} onSearchChange={onSearchChange} />
    </Suspense>
  );
}
